import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

import { adminMessagesService } from '../../../services/adminContentService';
import Button from '../../../components/ui/Button';


const RecentActivity = ({ userType }) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async () => {
    try {
      const response = await adminMessagesService?.getForCurrentPlayer();
      setActivities(response?.data || []);
    } catch (error) {
      console.error('Error fetching activities:', error);
    } finally {
      setLoading(false);
    }
  };

  const getIconColorClass = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary',
      success: 'bg-success/10 text-success',
      accent: 'bg-accent/10 text-accent',
      warning: 'bg-warning/10 text-warning',
      error: 'bg-error/10 text-error'
    };
    return colors?.[color] || colors?.primary;
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins} ${diffMins === 1 ? 'minute' : 'minutes'} ago`;
    if (diffHours < 24) return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <div className="flex items-center justify-center py-8">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-card">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-foreground font-headline flex items-center gap-2">
          <Icon name="Activity" size={24} className="text-primary" />
          Recent Activity
        </h2>
        <Button variant="ghost" size="sm" iconName="RefreshCw" onClick={() => {}}>
          Refresh
        </Button>
      </div>
      <div className="space-y-3">
        {activities?.map((activity) => (
          <div
            key={activity?.id}
            className="flex items-start gap-4 p-4 rounded-lg border border-border hover:bg-muted transition-colors duration-300"
          >
            <div className={`w-10 h-10 rounded-lg ${activity?.color} flex items-center justify-center flex-shrink-0`}>
              <Icon name={activity?.icon} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">{activity?.title}</p>
              <p className="text-xs text-muted-foreground">{activity?.description}</p>
              <p className="text-xs text-muted-foreground mt-1">{activity?.timestamp}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;